var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"table-header-item",class:{'th-first' : _vm.isFirst}},[_c('p',{staticClass:"table-header-text"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('i',{staticClass:"sort-down-icon fas fa-sort-down fa-2x pb-2"})])
}
var staticRenderFns = []

export { render, staticRenderFns }